<h2 mat-dialog-title>Edit Dates: {{ data.personName }}</h2>
<mat-dialog-content>
  <form
    [formGroup]="dateForm"
    fxLayout="row"
    fxLayoutAlign="space-between"
    fxLayoutGap="16px"
    style="margin-top: 16px"
  >
    @if (data.showFor !== 'endDate') {
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        [fxFlex]="data.showFor === 'startDate' ? '100%' : '48%'"
      >
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
          [errorStateMatcher]="matcher"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        @if (dateForm.hasError('startDateBeforeEndDate')) {
          <mat-error> Start date must be before the end date </mat-error>
        }
        @if (dateForm.hasError('requiredStartDate')) {
          <mat-error> Start date is required if an end date is set </mat-error>
        }
      </mat-form-field>
    }
    @if (data.showFor !== 'startDate') {
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        [fxFlex]="data.showFor === 'endDate' ? '100%' : '48%'"
      >
        <mat-label>End Date</mat-label>
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
          [errorStateMatcher]="matcher"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (dateForm.hasError('startDateBeforeEndDate')) {
          <mat-error> End date must be after the start date </mat-error>
        }
        @if (dateForm.hasError('requiredStartDate')) {
          <mat-error> Start date is required if an end date is set </mat-error>
        }
      </mat-form-field>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!dateForm.valid || saving"
    (click)="save()"
  >
    Update
  </button>
</mat-dialog-actions>
